import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { AuthService } from '@app/shared/services';
import { TargetResourceService } from '@state/target-resource';
import { UserRepository, UserService } from '@state/user';

@Injectable({ providedIn: 'root' })
export class TargetResourceGuard {
  private authService = inject(AuthService);
  private router = inject(Router);
  private targetResourceService = inject(TargetResourceService);
  private userRepository = inject(UserRepository);
  private userService = inject(UserService);

  canActivate(): Observable<boolean> | boolean {
    let loggedIn = this.authService.loggedIn();

    if (loggedIn) {
      if (!this.userRepository.getHasFetchedUser()) this.userService.setUserFromAuth();
      return this.targetResourceService.getTargetResource$().pipe(
        map((targetResourceResponse) => {
          this.targetResourceService.navigateBasedOnResponse(targetResourceResponse);
          return false;
        })
      );
    } else {
      let redirectUrl = window.location.href;
      void this.router.navigate(['/login'], { queryParams: { redirectUrl } });
      return false;
    }
  }
}
